module.exports = __webpack_public_path__ + "img/auction.fa660034.png";